<template>
<v-toolbar 
    v-if="restaurant" app class="pl-0"
>
    <v-toolbar-side-icon @click="$emit('menu')">
    </v-toolbar-side-icon>
    <div class="ml-2 hidden-xs-only">
        <v-img width="80px" class="photo sp-link" contain aspect-ratio="1.5"
            :src="'https://api.socialplace.com.br'+((restaurant.photo)?restaurant.photo:restaurant.tag_photo)"
        ></v-img>
    </div>
    <v-toolbar-title id="title">
        <span>
        {{ restaurant.restaurantname }}
        </span>
        <v-dialog v-model="opening" lazy max-width="860px"
            persistent scrollable 
        >
            <sp-opening-settings @close="opening = false">
            </sp-opening-settings>
        </v-dialog>
        <v-dialog v-model="importDialog" lazy max-width="800px"
            persistent scrollable 
        >
            <sp-import-products v-if="importDialog" @close="importDialog = false">
            </sp-import-products>
        </v-dialog>
    </v-toolbar-title>
    <!-- <div class="sp-search hidden-md-and-down">
        <v-layout row justify-center="">
            <v-flex sm10>
                <v-text-field
                class="hidden-sm-only"
                :label="$t('home.search')"
                solo clearable
                light
                flat
                :loading="searching"
                hide-details
                :append-icon="($vuetify.breakpoint.smAndUp)?'tune':''"
                @click:append="_=>$store.state.subtypes=true"
                prepend-inner-icon="search"
                type="text"
                disabled
                ></v-text-field>
            </v-flex>
        </v-layout>
    </div> -->
    <!-- <v-layout row justify-center pb-1>
        <v-flex sm6>
            <v-text-field
            class="hidden-sm-and-up"
            :label="$t('home.search')"
            solo clearable
            light
            flat
            :loading="searching"
            @focus="$store.state.hideCard=true"
            @blur="$store.state.hideCard=false"
            hide-details
            :append-icon="($vuetify.breakpoint.smAndUp)?'tune':''"
            @click:append="_=>$store.state.subtypes=true"
            prepend-inner-icon="search"
            type="text"
            disabled
            ></v-text-field>
        </v-flex>
    </v-layout> -->

    <!-- <span class="subheading mr-4"> {{endereco}}</span> -->
    <v-spacer></v-spacer>
    <!-- <span class="text-uppercase mr-4 hidden-xs-only"
    v-bind:class="aberto"
    >
        {{(restaurant.aberto)?$t('restaurant.open'):$t('restaurant.close')}}
    </span> -->
    <v-btn @click="opening = true" flat color="accent" class="hidden-xs-only">
        <v-icon>access_time</v-icon>
        <span class="pl-2 hidden-sm-only">Horário de funcionamento</span>
    </v-btn>
    <v-btn color="success" :href="`https://${restaurant.webapp_link}.pediragora.app/home`"
        target="_blank" class="hidden-xs-only">
        Visualizar
        <v-icon right>open_in_new</v-icon>
    </v-btn>
    <v-menu offset-y bottom left>
    <template v-slot:activator="{ on }">
        <v-toolbar-side-icon v-on="on">   
            <v-icon>more_vert</v-icon>
        </v-toolbar-side-icon>
    </template>
    <v-list>
        <v-list-tile :href="`https://${restaurant.webapp_link}.pediragora.app/home`" 
            target="_blank"
        >
            <v-list-tile-title>Testar</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="opening = true">
            <v-list-tile-title>Horário de funcionamento</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="importDialog = true">
            <v-list-tile-title>Importação</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="{name:'Company'}">
            <v-list-tile-title>Dados fiscais</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout">
        <v-list-tile-title>Sair</v-list-tile-title>
        </v-list-tile>
    </v-list>
    </v-menu>
</v-toolbar>
</template>

<script>
import {mapGetters} from 'vuex'

import SpOpeningSettings from "../components/SpOpeningSettings"
import SpImportProducts from "../components/SpImportProducts";

export default {
    components:{
        SpOpeningSettings,
        SpImportProducts
    },
    data(){
        return {
            info:false,
            searching:false,
            toggle:{
                name:false
            },
            tooltip:false,
            menu:false,
            tip:true,
            opening:false,
            importDialog:false
        }
    },
    methods:{
        logout(){
            this.$store.commit("LOGOUT")
            this.$router.go({name:"Login"})
        }
    },
    computed: {
        ...mapGetters([
            'restaurant',
            'typeSelected',
            'user'
        ]),
        drawer:{
        get(){
            return this.$store.state.drawer
        },
        set(value){
            return this.$store.state.drawer = value
        }
        },
        aberto(){
           return (this.restaurant.aberto)?'green--text':'red--text'
        },
    },
}
</script>

<style lang="scss" scoped>
    .sp-profile{
        border-radius: 50%;
    }
    .sp-search{
        position: absolute;
        top:5px;
        right:450px;
        width:calc(100% - 900px);
    }
</style>

